import React, { Component } from 'react'
import './Skills.css'
import SkillsData from '../../const/skills_data'
import SkillItem from '../skill_item/SkillItem'
import { Card, CardColumns } from 'react-bootstrap'
import Zoom from 'react-reveal/Zoom';

export default class Skills extends Component {
    render() {
        return (
            <div id="skills" className="skills">
                <h4> Skills</h4>
                <CardColumns>


                    {SkillsData.map(skill =>


                        <Zoom >
                            <Card className="text-center">
                                <Card.Body>
                                    <Card.Title>{skill.Type}</Card.Title>
                                    <Card.Text>

                                        {skill.data.map(el => <SkillItem key={el.id} skill={el} />)}

                                    </Card.Text>

                                </Card.Body>
                            </Card>
                        </Zoom>

                    )}

                </CardColumns>

            </div>
        )
    }
}
